import Header from "components/Headers/Header";
import TabsInfoModal from "components/Modal/TabsInfoModal";
import React, { useState } from "react";
import { Card, Col, Container, Row } from "reactstrap";

const AdminDuties = () => {
  const infoPoints = [
    "This module helps the admin manage daily, weekly, and monthly operational tasks, including financial checks, user requests, store orders, strategy reviews, and platform growth planning.",
  ];
  const subPoints = [];
  const infoTitle = "Admin Duties Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  return (
    <>
      <Header />
      <Container>
        <Row>
          <h2
            className="mb-0 ml-auto m-2 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </Row>

        <Row className="g-3">
          <Col xs="12" md="12" lg="4" className="mb-3 mb-lg-0">
            <Card className="p-3">
              <h3>
                <u>Daily</u>
              </h3>
              <ul className="hide-bullets p-0">
                <li>Check money accounts</li>
                <li>Check bills due and payable</li>
                <li>Check FHP email acct</li>
                <li>Check Resolution center</li>
                <li>Check Orders at Store</li>
                <li>Check School Contract requests</li>
                <li>Check Tech Forum & Trello</li>
                <li>Check Trending</li>
                <li>Check Business of College Sports</li>
                <li>Check Request Cities</li>
                <li>Check Request Schools</li>
              </ul>
            </Card>
          </Col>
          <Col xs="12" md="12" lg="4" className="mb-3 mb-lg-0">
            <Card className="p-3">
              <h3>
                <u>Weekly</u>
              </h3>
              <ul className="hide-bullets p-0">
                <li>Check sales</li>
                <li>Check supplies</li>
                <li>Check survey</li>
              </ul>
            </Card>
          </Col>
          <Col xs="12" md="12" lg="4" className="mb-3 mb-lg-0">
            <Card className="p-3">
              <h3>
                <u>Monthly</u>
              </h3>
              <ul className="hide-bullets p-0">
                <li>Check opportunities in marketplace</li>
                <li>Review Strategy for growth & ads revenue</li>
                <li>Outline programming needs</li>
              </ul>
            </Card>
          </Col>
        </Row>
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
    </>
  );
};

export default AdminDuties;
